import { render, staticRenderFns } from "./sortie-hospitalisation.vue?vue&type=template&id=6421a47c&scoped=true"
import script from "./sortie-hospitalisation.vue?vue&type=script&lang=js"
export * from "./sortie-hospitalisation.vue?vue&type=script&lang=js"
import style0 from "./sortie-hospitalisation.vue?vue&type=style&index=0&id=6421a47c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421a47c",
  null
  
)

export default component.exports